import PropTypes from 'prop-types';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

const Default = (colors) => {
  const { red, gold, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  // Custom primary color palette - Black (#1E1E1E)

  const primaryColors = [
         '#E8EDF3', // lighter
         '#C5D2E0', // 100
         '#A0B5CC', // 200
         '#7A99B8', // light
         '#557CA5', // 400
         '#0A2138', // main
         '#081D31', // dark
         '#07192A', // 700
         '#05101C', // darker
         '#030810'  // 900
      ];

      
    const secondaryColors = [
         '#E8F0FE', // lighter
         '#C2D9FA', // 100
         '#9BBEF5', // 200
         '#74A3F0', // light
         '#4886EA', // 400
         '#1B64D4', // main
         '#1653B0', // dark
         '#11428C', // 700
         '#0C3168', // darker
         '#082044'  // 900
      ];


    const tertiaryColors = [
      '#E8F9F1', // lighter
      '#C2EEDA', // 100
      '#9BE3C2', // 200
      '#74D8AA', // light
      '#50CE96', // 400
      '#2BC48B', // main
      '#25A877', // dark
      '#1F8C63', // 700
      '#19704F', // darker
      '#13543B'  // 900
   ];



  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      main: secondaryColors[5],
      600: secondaryColors[6],
      dark: secondaryColors[7],
      800: secondaryColors[8],
      darker: secondaryColors[9],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: '#fff'
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    tertiary: {
      lighter: tertiaryColors[0],
      100: tertiaryColors[1],
      200: tertiaryColors[2],
      light: tertiaryColors[3],
      400: tertiaryColors[4],
      main: tertiaryColors[5],
      600: tertiaryColors[6],
      dark: tertiaryColors[7],
      800: tertiaryColors[8],
      darker: tertiaryColors[9],
      contrastText
    },
    info: {
      lighter: tertiaryColors[0],
      light: tertiaryColors[3],
      main: tertiaryColors[5],
      dark: tertiaryColors[7],
      darker: tertiaryColors[9],
      contrastText
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
};

Default.propTypes = {
  colors: PropTypes.object
};

export default Default;
